import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tooltip, Image } from '@codex-brightworld/basics';
import { Icon } from '@codex-brightworld/icons';

const ProductTooltip = styled(Tooltip)`
  left: -25px;
  top: 15px;
  width: 150px;
`;

const TickIcon = styled(Icon)`
  &.dc-icon {
    stroke: none;
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
  svg {
    width: 20px;
    height: 20px;
  }
  svg path:last-child {
    fill: ${({ theme }) => theme.colors.neutral.grey[4]};
  }
`;

const PricePsan = styled.div`
    margin: 10px 0;
    font-size: 18px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.neutral.currysBlack};
    clear: both;
`;

const PriceSavedSpan = styled.span`
    margin-left: 7px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.primary.magenta};
`;

const EmailMeBackLink = styled.a`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.primary.purple};
`;

class ProductSwatchTooltip extends PureComponent {
  renderProductFeature(productFeature) {
    return (
      <li
        className={'dc-product-tooltip-feature'}
        key={productFeature}
      >
        <TickIcon icon={'tick'} size={'large'} />
        <span>
          {productFeature}
        </span>
      </li>
    );
  }

  render() {
    const { product } = this.props;
    return (
      <ProductTooltip arrow={'top'} textAlign={'center'} floating>
        <article>
          <a href={product.product_url} className={'dc-product-tooltip-link'}>
            <Image lazy alt={''} image={product.img_url} />
          </a>

          {product.product_features && (
            <ul className={'dc-product-tooltip-features'}>
              {product.product_features.map((feature) => (this.renderProductFeature(feature)))}
            </ul>
          )}

          <PricePsan
            dangerouslySetInnerHTML={{ __html: product.price }}
          />

          {(product.saving || product.was_price) && (
            <div className={'dc-product-tooltip-discount'}>
              {product.was_price && (
              <span
                className={'dc-product-tooltip-was-price'}
                dangerouslySetInnerHTML={{
                  __html: `Was ${product.was_price} `
                }}
              />
              )}
              {product.saving && (
              <PriceSavedSpan
                dangerouslySetInnerHTML={{
                  __html: `${this.props.priceSaveTranslate} ${product.saving}`
                }}
              />
              )}
            </div>
          )}

          {product.out_of_stock && (
            <div className={'dc-product-tooltip-stock-info'}>
              {this.props.outOfStockTranslate}
            </div>
          )}

          {product.show_email_me_back_link && (
            <EmailMeBackLink
              href={`${product.product_url}#email-when-back-desktop`}
            >
              {this.props.emailMeWhenBackInStockTranslate}
            </EmailMeBackLink>
          )}
        </article>
      </ProductTooltip>
    );
  }
}

ProductSwatchTooltip.propTypes = {
  product: PropTypes.shape({
    fupid: PropTypes.string,
    img_url: PropTypes.string,
    out_of_stock: PropTypes.bool,
    price: PropTypes.string,
    was_price: PropTypes.string,
    product_url: PropTypes.string,
    product_features: PropTypes.arrayOf(PropTypes.string),
    saving: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string
    ]),
    show_email_me_back_link: PropTypes.bool,
    swatch_img_url: PropTypes.string,
    variant: PropTypes.string
  }).isRequired,
  priceSaveTranslate: PropTypes.string.isRequired,
  outOfStockTranslate: PropTypes.string.isRequired,
  emailMeWhenBackInStockTranslate: PropTypes.string.isRequired
};

ProductSwatchTooltip.displayName = 'ProductSwatchTooltip';

export default ProductSwatchTooltip;
